import React, { useEffect, useState } from "react";
import axios from "axios";
import { ClipboardCheck } from "lucide-react";
import { PortalScreen } from "@/components/portal/lp/PortalScreen";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/re/portal/resident/weekly-questions`;

function Questions({ d }) {
  const picked = Object.fromEntries((d.last?.answers || []).map((x) => [x.no, x.option]));
  return (
    <div className="space-y-6" data-testid="weekly-questions">
      <p className="text-sm text-white/60" data-testid="wq-readonly-note">Read these before your check-in. Your staff member goes through them with you and records your answers.</p>
      {d.last && <p className="text-xs text-white/50" data-testid="wq-last">Highlighted: your answers from {new Date(d.last.submitted_at).toLocaleDateString()}.</p>}
      {d.questions.map((q) => (
        <fieldset key={q.no} className="space-y-2" data-testid={`wq-${q.no}`}>
          <legend className="text-[11px] uppercase tracking-[0.2em] text-[#d4a017]">{d.groups[q.group]} · {q.no} of {d.questions.length}</legend>
          <div className="font-medium">{q.prompt}</div>
          {q.options.map((o) => (
            <div key={o.id} data-testid={`wq-${q.no}-${o.id}`} className={`p-3 rounded-lg border text-sm ${picked[q.no] === o.id ? "border-[#d4a017] bg-[#d4a017]/10 text-white" : "border-white/10 text-white/80"}`}>{o.text}</div>
          ))}
        </fieldset>
      ))}
    </div>
  );
}

/** Home-tab card: this week's 10 check-in questions, read-only for the resident (staff record the answers). */
export default function WeeklyQuestions({ token }) {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  const load = () => axios.get(API, { params: { token } }).then((r) => setD(r.data)).catch(() => setD(null));
  useEffect(() => { load(); }, [token]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="wq-open" className="w-full flex items-center gap-3 rounded-xl border border-[#d4a017]/50 bg-[#d4a017]/10 p-4 text-left">
        <ClipboardCheck className="h-6 w-6 text-[#d4a017]" /><span><span className="block font-medium">Your weekly check-in questions</span><span className="text-xs text-white/60">{d.due ? "Read them before your check-in · your staff member records your answers" : `Answered this week · next ones open ${d.next_on}`}</span></span>
      </button>
      {open && <PortalScreen title="Weekly check-in" onBack={() => setOpen(false)} testid="wq-screen"><Questions d={d} /></PortalScreen>}
    </>
  );
}
